module.exports = "/images/london-6.jpg";